<script lang="ts">
  import type { CurrentPrice } from "../../../../types/CinemaProductsDto.types.ts";
  import { showCurrentSaleColor } from "../../e3823.ts";

  interface Props {
    current: CurrentPrice;
    isUvp: boolean;
  }

  const { current, isUvp }: Props = $props();
</script>

<div class:sale={current.isSale && showCurrentSaleColor(isUvp)}>
  {current.price}
</div>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  div {
    font: tokens.$oc-semantic-font-headline-50;
    white-space: nowrap;
    text-decoration: var(--tile-hover-decoration-none);
  }

  .sale {
    color: tokens.$oc-semantic-color-text-sale;
  }
</style>
